var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.32942 18C8.05146 17.9959 7.78494 17.8802 7.5822 17.6754L0.241046 9.77191C0.0738118 9.55254 -0.0116517 9.27404 0.0012793 8.99058C0.0142103 8.70713 0.124611 8.43899 0.311008 8.23831C0.497405 8.03764 0.74647 7.91878 1.00976 7.90486C1.27305 7.89093 1.53173 7.98295 1.7355 8.16299L8.32942 15.2761L22.2645 0.259511C22.4683 0.0794662 22.727 -0.0125442 22.9902 0.00137729C23.2535 0.0152988 23.5026 0.134157 23.689 0.334832C23.8754 0.535506 23.9858 0.80365 23.9987 1.08711C24.0117 1.37056 23.9262 1.64906 23.759 1.86843L9.07665 17.6754C8.8739 17.8802 8.60739 17.9959 8.32942 18Z",
    fill: "#01509F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.d3a3172a9e20bd0ca2993058fef9eb91.svg";
export { ForwardRef as ReactComponent };